import { z } from 'zod'

// `?job=J123455` deep-links a page to a job. TanStack parses numeric-looking
// values as numbers, so coerce back to a string.
export const jobSearchSchema = z.object({
  job: z.coerce.string().trim().min(1).optional().catch(undefined),
})

export type JobSearch = z.infer<typeof jobSearchSchema>
